import React from "react";

const StepSm = ({ img, number, descripcion }) => {
  return (
    <li className='d-flex flex-row align-items-center my-2'>
      <h1 className='step__number'>{number}</h1>
      <img className='step__icon' src={img} alt='' style={{ height: "99px" }} />
      <p className='step__description' style={{ fontSize: "20px" }}>
        {descripcion}
      </p>
    </li>
  );
};

export default StepSm;
